<template>
  <div class="app-footer">
    <!-- <p class="footer-text">Made with ❤️ in Surabaya</p> -->
    <p class="copyright">&copy; 2026 Universitas Kristen Petra</p>
  </div>
</template>

<script setup>
</script>

<style scoped>
.app-footer {
  background: transparent;
  color: #4489c6;
  padding: 2rem;
  text-align: center;
  font-weight: 500;
}
.copyright {
  font-size: 0.8rem;
  opacity: 0.7;
  margin-top: 0.25rem;
}
@media (max-width: 768px) {
  .app-footer {
    padding: 1.5rem 1rem;
  }
  .footer-text {
    font-size: 0.7rem;
  }
  .copyright {
    font-size: 0.7rem;
  }
}
</style>